import {
  AttentionResult,
  getAttentionLevel,
} from "@/components/Attention/landmarks/get-attention-level";
import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class AttentionRest {
  baseURL = {
    attention: "/attention",
    log: "/log",
  };

  startDetector(
    files: HTMLImageElement[] | File[],
    fps: number
  ): Promise<AttentionResult> {
    return getAttentionLevel(this.baseURL.attention, {
      images: files,
      fps: fps,
    });
  }

  updateAttentionConfig(data: any): Observable<any> {
    const url: string = `/global-configurations/attention-configurations`;
    return api.put(url, data, {});
  }

  getAttentionConfig(): Observable<any> {
    const url: string = `/global-configurations`;
    return api.get(url);
  }

  attentionLog(data: any): Observable<any> {
    const url: string = `/userlog`;
    return api.post(url, data, {}, this.baseURL.log);
  }
}
